import { COOKIE_CONSENT, DEFAULT_PREFERENCES } from './mutations'
import {
  NECESSARY_CONSENT, ANALYTICAL_CONSENT, FUNCTIONAL_CONSENT, PERSONALIZED_CONSENT
} from './config'

export default {
  namespaced: true,
  state: {
    cookieConsent: [],
    defaultPreferences: {
      all: false,
      [NECESSARY_CONSENT]: true,
      [ANALYTICAL_CONSENT]: false,
      [FUNCTIONAL_CONSENT]: false,
      [PERSONALIZED_CONSENT]: false
    }
  },
  mutations: {
    [COOKIE_CONSENT](state, data) {
      state.cookieConsent = data
    },
    [DEFAULT_PREFERENCES](state, data) {
      state.defaultPreferences = data
    }
  },
  actions: {
    cookieConsent(context, value) {
      context.commit(COOKIE_CONSENT, value)
    },
    defaultPreferences(context, value) {
      context.commit(DEFAULT_PREFERENCES, value)
    }
  },
  getters: {
    cookieConsent(state) {
      return state.cookieConsent
    },
    defaultPreferences(state) {
      return state.defaultPreferences
    }
  }
}
